import { Component, OnInit } from "@angular/core";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";



@Component({
  selector: 'app-registrationLicense',
  templateUrl: './registrationLicense.component.html'
})

export class RegistrationLicenseComponent implements OnInit {

  currentTab:number;

  constructor(public adminService: AdminService,
    public sharedService: SharedService) { };

  ngOnInit(): void {
    this.currentTab = 0;
  }

  tabVisible(type: string): boolean {
    // TODO
    return true;
  }

}
